import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { FilterBar } from '@agyletime/vue-3-common/src/typings/filter';
import { useLogger } from '@agyletime/vue-3-common/src/composables/logger';

const logger = useLogger('loadDependencies');
export interface EventCount extends FilterBar.SelectItemValue {
    _id?: string;
    eventLevel?: string;
    count: number;
    service?: string;
    services?: string[];
    types?: string[];
    original?: EventCount;
    value: FilterBar.SelectedItemValues;
}
type FilterValue = FilterBar.FilterValue;
export type SelectedEvents = Record<string, FilterValue>

export const getEventCounts = async () => {
    // const eventTypes = [{ _id: 'test', count: 1, name: 'test (1)' }];
    // const eventLevels = [{ _id: 'info', count: 1, name: 'info (1)' }];
    // return { eventTypes, eventLevels };
    const eventCounts: Array<EventCount[]> = await fetchFromLambda('/event-logs/events/counts');
    // Only returning the raw Event Types
    return eventCounts[0];
};

export const getStartOfWeekConfig = async () => {
    const fallback = 1; // monday
    let weekStart = fallback;
    try {
        const config: { startWeekOn?: number } = await fetchFromLambda('/organisation/organisations/me');
        weekStart = config?.startWeekOn ?? fallback;
    } catch (err) {
        logger.error(err);
        // do Nothing
    }
    const filterData = { weekStart: weekStart };

    return { filterData };
};